import { Base } from './_base.model';

export class Question extends Base {
  id: number;
  text: string;
  type_id: string;
  scope: string;
  active: boolean;
  choices: string;
  values: string;
  other: boolean;
  na: boolean;
  formatting: string;
  always_required: boolean;
  required_if_question_id: number | null;
  required_if_value: string | null;
  required_if_fields: string[] | null;
  required_if_dropdown_names: string[] | null;
  exclusive_question_id: number | null;
  visibility_condition_applied: boolean;
  visibility_command: string;
  visibility_condition_subject_id: number | null;
  visibility_condition_operator: string;
  visibility_condition_value: string;
  strong_disagree_label: string;
  strong_agree_label: string;
  field_id: string;
  compliance_violation_enabled: boolean;
  compliance_violation_if: string;
  after_sis_completed: boolean;
  compliance_violation_applied: boolean;
  compliance_violation_operator: string;
  compliance_violation_value: string;
  confirm: boolean;
  row_headers: string;
  allow_add_rows: boolean;
  /** TABLE: read-only Total row summing the Number / Amount columns. */
  show_total?: boolean;
  table_question_ids: number[] | null;
  column_type_id: string;

  deleted: boolean;
  archived: boolean;
  type: any;

  constructor() {
    super();
    this.type = {};
  }
}

